import { CustomField } from 'projects/core/src/include/structures';
import { Shops } from './shops';
import { Address } from "./address";


export class ContractsInstallment{
    id:number;
    date:Date;
    number:number;
    amount:number;
    status:number;
    phase:number;

}

export class Contracts{
    id:number;
    start:any;
    end:any;
    id_shop:number;
    amount:number;
    amount_type:number;
    tax:number;
    gross:number;
    frequency:number;
    id_type:number;
    type:string;
    status:number;
    note:string;
    description:string;
    shop:Shops;
    customfields:CustomField[];
    installations:any[];
    phase:number;
    installments:ContractsInstallment[];
    files:File[];
    id_address:number;
    addressItem:Address;
    signature:any;
    signature_file:string;
    signature_date:string;
    signature_user:number;

}